//import { css } from '@emotion/core'
//import { variables } from 'cssInJs'

export default{
    noResultText :{
        textAlign: 'center',
        marginTop: '1rem',
        fontWeight: 600
    }
}